import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-gray-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Card className="border-0 shadow-xl">
          <CardHeader>
            <div className="flex items-center gap-3 mb-2">
              <FileText className="w-8 h-8 text-orange-500" />
              <CardTitle className="text-3xl">Aviso Legal</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none">
            <h2>Datos Identificativos</h2>
            <p>
              En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, 
              de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan 
              los siguientes datos:
            </p>
            
            <ul>
              <li><strong>Titular:</strong> Strategos Overland by Javi Garmendia</li>
              <li><strong>Domicilio:</strong> Calle Turín 25, Parla (Madrid) 28983</li>
              <li><strong>Correo electrónico:</strong> hola@sttgs-overland.com</li>
              <li><strong>Sitio Web:</strong> event-overland.preview.emergentagent.com</li>
            </ul>

            <h2>Usuarios</h2>
            <p>
              El acceso y/o uso de este portal atribuye la condición de USUARIO, que acepta, desde dicho acceso 
              y/o uso, las Condiciones Generales de Uso aquí reflejadas. Las citadas Condiciones serán de aplicación 
              independientemente de las Condiciones Generales de Contratación que en su caso resulten de obligado cumplimiento.
            </p>

            <h2>Uso del Portal</h2>
            <p>
              El sitio web y sus servicios son de acceso libre y gratuito. No obstante, algunos servicios pueden estar 
              condicionados a la previa cumplimentación del correspondiente formulario de registro.
            </p>

            <h2>Propiedad Intelectual e Industrial</h2>
            <p>
              Todos los contenidos del sitio web, salvo que se indique lo contrario, son titularidad exclusiva de 
              Strategos Overland y, por tanto, están protegidos por las leyes de propiedad intelectual e industrial.
            </p>

            <h2>Exclusión de Garantías y Responsabilidad</h2>
            <p>
              Strategos Overland no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier 
              naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, 
              falta de disponibilidad del portal o la transmisión de virus o programas maliciosos.
            </p>

            <h2>Modificaciones</h2>
            <p>
              Strategos Overland se reserva el derecho de efectuar sin previo aviso las modificaciones que considere 
              oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se 
              presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados en su portal.
            </p>

            <h2>Enlaces</h2>
            <p>
              En el caso de que en el sitio web se dispusiesen enlaces o hipervínculos hacia otros sitios de Internet, 
              Strategos Overland no ejercerá ningún tipo de control sobre dichos sitios y contenidos.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
